import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { BRANCH_MANAGER, MANAGER } from '../constants/permissions'

const useGetSalesperson = (divisionId, config = {}) => {
  const [options, setOptions] = useState([])
  const { canSalespersonsView } = config

  const { hasManagerPermission, divisionId: userDivisionId } = useSelector((state) => ({
    hasManagerPermission: [MANAGER, BRANCH_MANAGER].some((el) => state.auth.user.permissions.includes(el)),
    divisionId: state.auth.user.division_id,
  }))

  useEffect(() => {
    const loadOptions = async () => {
      if (canSalespersonsView || hasManagerPermission) {
        const response = await axios.get('/users/salespersons', {
          params: { divisionId: divisionId || userDivisionId },
        })
        if (response.status === 200) {
          setOptions(response.data)
        }
      }
    }
    loadOptions()
  }, [divisionId])

  return { options }
}

export default useGetSalesperson
